import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/_service/user.service';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {
    @Input() title: string = '';
    
    activeTab: string = '';
    permissions: Array<string> = this.userService.permissions

    constructor(
        private userService: UserService,
        private router: Router
    ) {

    }
    ngOnInit(): void {
        const raw = this.router.url || '';
        const path = raw.split('?')[0].split('#')[0];
        if (path.startsWith('/administrative')) {
            const remainder = path.replace(/^\/administrative\/?/, '');
            this.activeTab = remainder.split('/')[0] || '';
        } else {
            const parts = path.replace(/^\//, '').split('/');
            this.activeTab = parts[0] || '';
        }
    }
    selectTab(tab: string, event?: Event) {
        if (event) { event.preventDefault(); }
        this.router.navigateByUrl('administrative'+(tab ? '/'+tab : ''));
        this.activeTab = tab;
    }
}
